import { EditLocationComponent } from './edit-location.component';
import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { updateLocations } from '../dashboard.actions';

export const EditLocation = connect(
  (state: AppState) => ({ sState: state }),
  { updateLocations }
)(EditLocationComponent as any) as unknown as typeof EditLocationComponent;
